import { render, staticRenderFns } from "./ButtonDeactivate.vue?vue&type=template&id=298622a3&scoped=true&"
import script from "./ButtonDeactivate.vue?vue&type=script&lang=js&"
export * from "./ButtonDeactivate.vue?vue&type=script&lang=js&"
import style0 from "./ButtonDeactivate.vue?vue&type=style&index=0&id=298622a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298622a3",
  null
  
)

export default component.exports